<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.tanimlama.baslikH1")}}</div>
        <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm" class="demo-ruleForm">
            <el-steps :active="active" finish-status="success" simple class="bg-white padding-20">
                <el-step title="Kategori ve Opsiyon" icon="el-icon-edit"></el-step>
                <el-step title="Ürün Bilgileri" icon="el-icon-upload">
                </el-step>
            </el-steps>
            <el-col v-if="active ===0" class="margin-top-10" :lg="24" :md="24" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <div class="yanForm card-base margin-top-10 animated fadeInUp transfer">
                        <el-row>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                <el-form-item class="formItem" prop="kategoriList">
                                    <el-transfer
                                            id="transfer1"
                                            v-model="urunForm.kategoriList"
                                            filterable
                                            :titles="['Kategori Listesi', 'Seçilen Kategoriler']"
                                            :format="{
                                                        noChecked: '${total}',
                                                        hasChecked: '${checked}/${total}'}"
                                            @change="kategoriChange"
                                            :data="kategoriListesi">
                                    </el-transfer>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                <el-form-item v-if="opsiyonVis" class="formItem" prop="opsiyonList">
                                    <el-transfer
                                            id="transfer2"
                                            v-model="urunForm.opsiyonList"
                                            filterable
                                            :titles="['Opsiyon Listesi', 'Seçilen Opsiyonlar']"
                                            :format="{
                                                        noChecked: '${total}',
                                                        hasChecked: '${checked}/${total}'}"
                                            @change="opsiyonChange"
                                            :data="opsiyonListesi">
                                        <el-button class="transfer-footer" slot="left-footer" type="primary"
                                                   style="float: left; margin-top: 8px"

                                                   @click="opsiyonDetayDialog = true" size="mini">Yeni
                                            Opsiyon
                                        </el-button>
                                    </el-transfer>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
            <el-row :gutter="10" v-if="active ===1">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs v-if="active ===1" tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white margin-top-10 animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             href="https://www.estasmedikal.com/tr/">
                                                        https://www.estasmedikal.com/tr/urunler/{{this.urunForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">http://www.artdoor.com.tr/tr/ </span>
                                                <el-input v-if="VisibleA" v-model="urunForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="urunForm.baslik"
                                                    v-on:change="linkTespit"
                                                    :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-model="urunForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane v-if="$store.state.dilDurum">
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.baslik"
                                                    v-on:change="urunForm.dil.en.seoBaslik = urunForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-model="urunForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit()"
                                                      @blur="seoIcerikDilTespit()"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="dil.en.seoBaslik">:
                                                <el-input
                                                        v-model="urunForm.dil.en.seoBaslik"
                                                        maxlength="60"
                                                        show-word-limit
                                                        :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="dil.en.seoIcerik">:
                                                <el-input type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikIngChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24"
                        v-for="(item,index) in secilenOpsiyonlar"
                        :key="index">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse v-model="collapseOps">
                            <el-collapse-item :title='item.label' :name="index" class="margin-top-10">
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                        style="margin-top: 5px">
                                    <el-form-item :label='item.label'>:
                                        <el-input v-if="item.konum === '1'"
                                                  v-model="opsiyonAciklamaForm.opsiyonBaslik[index]"></el-input>
                                        <ckeditor v-if="item.konum === '0'" :editor="editor"
                                                  :config="editorConfig"
                                                  v-model="opsiyonAciklamaForm.opsiyonBaslik[index]"></ckeditor>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"
                                        style="margin-top: 5px">
                                    <el-form-item :label='item.label+"(İngilizce)"'>:
                                        <el-input v-if="item.konum === '1'"
                                                  v-model="opsiyonAciklamaForm.opsiyonBaslikEn[index]"></el-input>
                                        <ckeditor v-if="item.konum === '0'" :editor="editor"
                                                  :config="editorConfig"
                                                  v-model="opsiyonAciklamaForm.opsiyonBaslikEn[index]"></ckeditor>
                                    </el-form-item>
                                </el-col>
                            </el-collapse-item>
                        </el-collapse>
                    </el-collapse>
                </el-col>
            </el-row>
            <el-col :span="24">
                <el-button v-if="active !==0" size="small" type="primary" style="float: left;margin-top: 15px;"
                           @click="back">Geri
                </el-button>
                <el-button v-if="active !==1" size="small" type="primary" style="float: right;margin-top: 15px;"
                           @click="next">İleri
                </el-button>
                <el-button v-if="active ===1" size="small" type="success" style="float: right;margin-top: 15px;"
                           @click="save">Kaydet
                </el-button>
            </el-col>
        </el-form>
        <el-dialog
                title="Opsiyon Konumu"
                :visible.sync="dialogKonum"
                width="50%">
            <el-row>
                <el-col :span="12">
                    <el-radio v-model="urunForm.opsiyonKonum" label="0" @change="changeKonum('0')">
                        <img src="../../../assets/images/13.png" alt="Alt" width="80%" height="80%">
                    </el-radio>
                </el-col>
                <el-col :span="12">
                    <el-radio v-model="urunForm.opsiyonKonum" label="1" @change="changeKonum('1')">
                        <img src="../../../assets/images/14.png" alt="Sağ" width="80%" height="80%">
                    </el-radio>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog
                title='Sunucudan Fotoğraf Seç'
                :visible.sync="dialogImgServerVisible"
                width="60%"
                center>
            <el-upload
                    action="#"
                    accept=".jpg,.jpeg,.png"
                    :on-change="serverImageUpload"
                    list-type="picture-card"
                    :file-list="imageListServer"
                    :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                </div>
            </el-upload>
        </el-dialog>
        <el-dialog
                title="Opsiyon İçerik"
                :visible.sync="opsiyonDetayDialog"
                width="50%">
            <el-form :model="opsiyonForm" ref="opsiyonForm">
                <el-row class="margin-top-10">
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslik")'>:
                            <el-input
                                    v-model="opsiyonForm.opsiyonBaslik"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonBaslikEn")'>:
                            <el-input
                                    v-model="opsiyonForm.opsiyonBaslikEn"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                        <el-form-item prop="yapiskan">
                            <el-switch
                                    v-model="opsiyonForm.yapiskan"
                                    active-value="1"
                                    inactive-value="0"
                                    active-text="Sabitle"
                                    inactive-text="Sabitleme">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.opsiyonKonum")'
                                      prop="opsiyonKonum">:
                            <el-button type="primary" size="mini" @click="dialogKonum = true">
                                Seç
                            </el-button>
                            &nbsp;
                            <img v-if="opsiyonForm.opsiyonKonum === '0'" style="float: right"
                                 src="../../../assets/images/13.png" width="20%" height="20%">
                            <img v-if="opsiyonForm.opsiyonKonum === '1'" style="float: right"
                                 src="../../../assets/images/14.png" width="20%" height="20%">
                        </el-form-item>
                    </el-col>
                    <el-button type="primary" size="mini"
                               @click="opsiyonTanimla('urunForm')">Opsiyon Tanımlama
                    </el-button>
                    <el-button size="mini" @click="opsiyonDetayDialog = false">Vazgeç</el-button>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';

    const VueScrollTo = require('vue-scrollto')
    Vue.use(VueScrollTo)
    import urunService from '../../../WSProvider/UrunService'
    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'

    let $ = JQuery;
    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "UrunTanimla",
        components: {},
        mounted() {
            this.getKategoriListesi();
        },
        data() {
            return {
                active: 0,
                opsiyonVis: false,
                dialogKonum: false,
                opsiyonDetayDialog: false,
                opsiyonDetayVis: false,
                konumText: "Seç",
                limit: 0,

                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikIngChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                kategoriListesi: [],
                opsiyonListesi: [],
                secilenOpsiyonlar: [],
                secilenOpsiyonlarPost: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5'],
                collapseOps: ['1'],
                visibleSil: false,
                checked: true,
                urunForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    urunKodu: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    resim: [],
                    kategoriList: [],
                    opsiyonList: [],
                    durum: "1",
                    dil: {
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        }
                    }
                },
                opsiyonForm: {
                    opsiyonBaslik: '',
                    opsiyonBaslikEn: '',
                    yapiskan: '0',
                    opsiyonKonum: '1',
                },
                opsiyonAciklamaForm: {
                    opsiyonBaslik: [],
                    opsiyonBaslikEn: [],
                },
                rulesUrun: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    ustKategori: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    urunKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            next() {
                if (this.active++ > 1) ;
            },
            back() {
                if (this.active-- > 0) ;
            },
            save() {
                let self = this;
                var dizi = [];
                var dil = [];
                this.urunForm.resim = [];
                this.$refs.urunForm.validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.urunForm.resim.push(e.name);
                        });
                        if (this.$store.state.dilDurum) {
                            dil = {
                                en: {
                                    baslik: this.urunForm.dil.en.baslik,
                                    altBaslik: this.urunForm.dil.en.altBaslik,
                                    icerik: this.urunForm.dil.en.icerik,
                                    seoBaslik: this.urunForm.dil.en.seoBaslik,
                                    seoIcerik: this.urunForm.dil.en.seoIcerik
                                }
                            };
                        }
                        for (var i = 0; i < this.secilenOpsiyonlar.length; i++) {
                            var item = ({
                                opsiyonKodu: this.secilenOpsiyonlar[i].opsiyonKodu,
                                aciklama: this.opsiyonAciklamaForm.opsiyonBaslik[i],
                                dil: {
                                    en: this.opsiyonAciklamaForm.opsiyonBaslikEn[i],
                                }
                            });
                            dizi.push(item)
                        }
                        urunService.urunTanimla(this.urunForm.urunKodu, this.urunForm.link, this.urunForm.baslik,
                            this.urunForm.altBaslik, this.urunForm.icerik, this.urunForm.resim, this.urunForm.seoBaslik,
                            this.urunForm.seoIcerik, this.urunForm.durum, dil, this.urunForm.kategoriList, dizi
                        ).then((response) => {
                            if (response.status === 200) {
                                notification.Status('success', this, 'Ürün Başarıyla Kaydedildi.');
                                this.active = 0;
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir ürün zaten mevcut!');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    } else {
                        notification.Status('warning', this, 'Doldurulması zorunlu olan alanları gözden geçiriniz!!');
                    }
                });
            },

            kategoriChange(value) {
                this.urunForm.kategoriList = value;
                this.getKategoriOpsiyonListesi();
                this.opsiyonVis = true;
            },
            linkTespitLink() {
                let self = this;
                if (this.urunForm.link) {
                    seoService.linkKontrol(self.urunForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.urunForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunForm.baslik) {
                                self.urunForm.seoBaslik = self.urunForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunForm.link = response.data;
                                }
                            } else if (!self.urunForm.baslik) {
                                self.linkVisible = false;
                                self.urunForm.link = '';
                                self.urunForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = strip_html_tags(this.urunForm.icerik);
                    this.urunForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.urunForm.dil.en.icerik);
                    this.urunForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('urun').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    var tip = file.raw["type"].split("/")[1];
                    if (this.urunForm.baslik) {
                        var imgname = randomText(13) + '-' + this.urunForm.link + ".png";
                    } else {
                        imgname = randomText(13) + '-' + linkTemizle(file.name.split('.')[0]) + ".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                $('.el-upload-list__item-delete').click();
                this.visibleSil = false;
            },
            getKategoriListesi() {
                let self = this;
                urunService.kategoriList().then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            let obj = self.kategoriListesi.find(data => data.key === e.ukategoriKodu);
                            if (obj === undefined) {
                                self.kategoriListesi.push({
                                    key: e.ukategoriKodu,
                                    label: e.baslik,
                                });
                            }
                        })
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            getKategoriOpsiyonListesi() {
                let self = this;
                if (this.urunForm.kategoriList.length !== 0) {
                    urunService.kategoriOpsiyonAllList(this.urunForm.kategoriList).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                let obj = self.opsiyonListesi.find(data => data.key === e.uOpsiyonKodu);
                                if (obj === undefined) {
                                    self.opsiyonListesi.push({
                                        key: e.uOpsiyonKodu,
                                        label: e.baslik,
                                        konum: e.konum,
                                    });
                                    self.urunForm.opsiyonList.push(e.uOpsiyonKodu)
                                }
                            });
                            this.opsiyonChange(self.urunForm.opsiyonList);
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            opsiyonChange(value) {
                this.secilenOpsiyonlar = [];
                this.urunForm.opsiyonList = value;
                for (var i = 0; i < this.urunForm.opsiyonList.length; i++) {
                    for (var k = 0; k < this.opsiyonListesi.length; k++) {
                        if (this.opsiyonListesi[k].key === this.urunForm.opsiyonList[i]) {
                            let obj = this.secilenOpsiyonlar.find(data => data.opsiyonKodu === this.urunForm.opsiyonList[i]);
                            if (obj === undefined) {
                                this.secilenOpsiyonlar.push({
                                    opsiyonKodu: this.urunForm.opsiyonList[i],
                                    label: this.opsiyonListesi[k].label,
                                    konum: this.opsiyonListesi[k].konum,
                                });
                            }
                        }
                    }
                }
                this.opsiyonDetayVis = true;
            },
            opsiyonTanimla(formName) {
                let dil = [];
                if (this.$store.state.dilDurum) {
                    dil = {
                        en: {
                            baslik: this.opsiyonForm.opsiyonBaslikEn,
                        }
                    };
                }
                urunService.urunOpsiyonTanimlama(this.opsiyonForm.opsiyonBaslik, this.opsiyonForm.yapiskan, this.opsiyonForm.opsiyonKonum, '1', dil, this.urunForm.kategoriList).then((response) => {
                    if (response.status === 200) {
                        this.opsiyonListesi.push({
                            key: response.data.uOpsiyonKodu,
                            label: response.data.baslik,
                        });
                        notification.Status('success', this, 'Opsiyon başarıyla eklendi.');
                        this.$refs[formName].resetFields();
                        this.opsiyonDetayDialog = false;
                    } else if (response.status === 230) {
                        notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir opsiyon zaten mevcut');
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        notification.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        notification.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }

            }
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        var str1 = str.replace(/<[^>]*>/g, '');
        return str1.replace(/&nbsp;/g, '');
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

</script>
<style scoped>
</style>
<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    #transfer1 {
        display: flex;
    }

    #transfer2 {
        display: flex;
        position: relative;
        left: 25px;
    }

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>